const LONG_ACCOUNT_NAME_LENGTH = 50;
const MEDIUM_ACCOUNT_NAME_LENGTH = 30;

/** @returns the font size to use for a given account name, considering its length */
export const useAccountNameFontSize = (name: string): number =>
  name.length < MEDIUM_ACCOUNT_NAME_LENGTH ? 24 : name.length < LONG_ACCOUNT_NAME_LENGTH ? 20 : 16;
